/* === Fix apertura foto corretta dopo cambio variante === */
/* === + Fix risoluzione massima nella modal (lightbox) ===
   Il tema genera per la modal un srcset con step 550 -> 1100: per le immagini
   con master < 1100px l'unica variante disponibile è 550w, che viene mostrata
   a tutto schermo sgranata. Questo script aggiunge al srcset la versione a
   risoluzione nativa (master) e imposta sizes=100vw (l'originale 'height 150vh'
   non è sintassi valida), così il browser carica sempre la risoluzione
   massima disponibile. */
document.addEventListener('DOMContentLoaded', function() {

  function getImageFilename(src) {
    if (!src) return null;
    return src.split('/').pop().split('?')[0];
  }

  function upgradeModalImage(img) {
    if (!img) return;
    var masterW = parseInt(img.getAttribute('width'), 10);
    var src = img.getAttribute('src');
    if (!masterW || !src) return;
    var srcset = img.getAttribute('srcset') || '';
    if (srcset.indexOf(' ' + masterW + 'w') === -1 && srcset.indexOf(masterW + 'w,') !== 0) {
      var candidate = src + ' ' + masterW + 'w';
      img.setAttribute('srcset', srcset ? srcset + ', ' + candidate : candidate);
    }
    img.setAttribute('sizes', '100vw');
  }

  function upgradeAllModalImages() {
    document.querySelectorAll('.product-media-modal .swiper-slide img').forEach(upgradeModalImage);
  }

  function syncModalFirstSlide() {
    const modal = document.querySelector('product-modal');
    if (!modal) return;

    const firstGalleryItem = document.querySelector('.product__media-item.swiper-slide');
    if (!firstGalleryItem) return;

    const firstGalleryImg = firstGalleryItem.querySelector('img');
    if (!firstGalleryImg) return;

    const firstModalImg = modal.querySelector('.swiper-slide img');
    if (!firstModalImg) return;

    /* Copia l'attributo src (URL a risoluzione master), NON currentSrc che può
       essere una variante piccola scelta dal browser per la griglia. */
    firstModalImg.src = firstGalleryImg.getAttribute('src') || firstGalleryImg.currentSrc || firstGalleryImg.src;
    firstModalImg.srcset = firstGalleryImg.getAttribute('srcset') || '';
    var gw = firstGalleryImg.getAttribute('width');
    var gh = firstGalleryImg.getAttribute('height');
    if (gw) firstModalImg.setAttribute('width', gw);
    if (gh) firstModalImg.setAttribute('height', gh);
    firstModalImg.sizes = '100vw';
    upgradeModalImage(firstModalImg);
  }

  /* Applica subito il fix a tutte le immagini della modal */
  upgradeAllModalImages();

  // Ascolta cambio variante
  document.addEventListener('change', function(e) {
    if (e.target.closest('.product-form, variant-radios, variant-selects')) {
      setTimeout(syncModalFirstSlide, 300);
    }
  });

  document.addEventListener('click', function(e) {
    const opener = e.target.closest('.product__modal-opener--image, .product__media-toggle');
    if (!opener) return;

    /* Sicurezza: riapplica il fix anche in apertura, nel caso il DOM sia stato rigenerato */
    upgradeAllModalImages();

    const mediaItem = opener.closest('.product__media-item.swiper-slide');
    if (!mediaItem) return;
    
    const img = mediaItem.querySelector('img');
    const filename = getImageFilename(img?.src);
    if (!filename) return;
    
    const modal = document.querySelector('product-modal');
    if (!modal) return;
    
    modal.style.opacity = '0';
    
    setTimeout(function() {
      modal.style.opacity = '1';
      
      const swiper = modal.querySelector('.swiper')?.swiper;
      if (!swiper) return;
      
      const modalSlides = [...modal.querySelectorAll('.swiper-slide')];
      const slideIndex = modalSlides.findIndex(slide => {
        const slideImg = slide.querySelector('img');
        return getImageFilename(slideImg?.src) === filename;
      });
      
      if (slideIndex !== -1) {
        swiper.slideTo(slideIndex, 0);
      } else {
        swiper.slideTo(0, 0);
      }
    }, 50);
  });
});